/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { css } from "@panda/css";

export const hoverLinkStyles = css({
	position: "absolute",
	w: "full",
	h: "full",
	borderRadius: "eds.borderRadius.24",
	outlineOffset: "eds.dimension.16",
	_focusVisible: {
		outline: "2px solid white",
	},
	"&&::before": {
		zIndex: 3,
	},
	"&:hover + .section-flex": {
		"& .asset-wrap img, & .asset-wrap video": {
			transform: "scale(1.05)",
		},
	},
});

export const sectionFlexStyles = css({
	[`& button, & a[href]:not(.clickable-box__link)`]: {
		position: "relative",
		zIndex: 3,
	},
});

export const assetWrapStyles = css({
	aspectRatio: "16 / 9",
	lg: {
		w: "1/2",
	},
	"--asset-border-radius": `24px`,
});

export const animateCustomCss = css.raw({ flexBasis: "50%" });
